import TmpStore from '@/view/weappTmp/core/lib/base/store.js'
import { ElementNode } from "./element-node"
import { CSSTransition } from '@/view/weappTmp/core/lib/public/css.js'
import { initData } from '@/view/weappTmp/core/mixin/registerConfig.js'

const itemTitleCSSMap = {
  'fontSize': {}, //标题字号
  'itemTitleToCmpDistance': {}, //标题距输入框距离
  'itemFontWeight': {} // 标题字体粗细
}
export class CompsNode{
  cnName = ''
  data = {}
  icon = ''
  name = ''
  props = []
  propsName = ''
  tooltip = ''
  type = ''
  id = null
  CSSSouce = {}
  _view = null

  // 初始化回显数据
  static transformCompsNode (arg,pedestalId){
    const {data,id} = arg
    const pedestalConfig = TmpStore.getVal(pedestalId)
    const findTmpMap = initData[pedestalConfig.type]
    const margeData = Object.assign({},findTmpMap[arg.name],{data,id}) 
    // console.log('transformCompsNode',margeData)
    return new CompsNode(margeData)
  }

  constructor (args){    
    this.init(args)
  }
  unconstructor (){
    TmpStore.$off(this.id)
    // this = null
  }
  init (args){    
    // 合并字段：base,props.value 至 cmp基础data
    if(!args.data){
      const defaultVal = {}
      args.props.forEach(d=>{
        defaultVal[d.key] = d.value
      })
      args.data = Object.assign({},args.base,defaultVal) 
    }
    for(let i in args){
      this[''+i] = args[i]
      if(i == 'props'&& args[i].map){
        this.props = args[i].map(d=>{
          const value = args.data[d.key]
          return new ElementNode(Object.assign({},d,{pid:args.id,value})) 
        }) 
      }
    }
    this.native()
  }
  // 初始化数据
  initData (){}
  // 实现数据响应式
  native (){
    const { id } = this
    TmpStore.$on(this.id, (data) => {        
      this.set('data',Object.assign(this.data,data))            
    })
  }
  // ctx: 视图组件的vue实例, 实现VM响应式
  viewNative (ctx){
    ctx.$set(ctx, 'viewData', this.data)
    this.cssStyleHandel(ctx)
    TmpStore.$on(this.id, () => {        
      ctx.$set(ctx, 'viewData', this.data)
      this.cssStyleHandel(ctx)
    })
  }
  // 处理当前组件CSS转换
  // ctx: 视图组件的vue实例
  cssStyleHandel (ctx,caller = 'self') {    
    let CSSSouce = JSON.parse(
      JSON.stringify(Object.assign(JSON.parse(JSON.stringify(ctx.baseConfig)), ctx.viewData))
    )
    if (caller == 'baseConfig') {
      CSSSouce = JSON.parse(
        JSON.stringify(Object.assign(ctx.viewData, JSON.parse(JSON.stringify(ctx.baseConfig))))
      )
    }
    ctx.$set(ctx, 'styleMerge', CSSTransition(CSSSouce, {}))
    let itemTitleCSSSouce = {}
    for (let i in itemTitleCSSMap) {
      itemTitleCSSSouce[i] = CSSSouce[i]
    }
    ctx.CSSSouce = CSSSouce
    ctx.$set(ctx, 'itemStyleMerge', CSSTransition(itemTitleCSSSouce, {}))
  }
  // 提交数据前格式化
  subDataFormat (){
    return {
      name: this.name,
      data: this.data,
      id: this.id,
      propsName: this.propsName
    }
  }     
  get (){
    
  }
  set (key,value){
    this[key] = value
  }
}